import { useState } from 'react';

interface CopyButtonProps {
  text: string;
}

export function CopyButton({ text }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard API not available — fail silently
      console.warn('Clipboard API not available');
    }
  };

  return (
    <button
      onClick={handleCopy}
      style={{
        fontSize: '12px',
        padding: '4px 12px',
        borderRadius: '6px',
        border: '1px solid var(--border)',
        background: copied ? 'var(--accent-bg)' : 'var(--bg-elevated)',
        color: copied ? 'var(--accent)' : 'var(--text-muted)',
        cursor: 'pointer',
        transition: 'all 0.2s',
        fontWeight: copied ? 600 : 400,
      }}
    >
      {copied ? '✓ Copied' : 'Copy'}
    </button>
  );
}
